import { isRouteErrorResponse, useRouteError, Link } from 'react-router';

export function RouteErrorFallback() {
  const error = useRouteError();

  let title = 'A apărut o eroare neașteptată';
  let message = 'Încercați să reîncărcați pagina sau reveniți la început.';

  if (isRouteErrorResponse(error)) {
    title = `Eroare ${error.status}`;
    message = typeof error.data === 'string' ? error.data : (error.statusText || message);
  } else if (error instanceof Error) {
    message = error.message;
  }

  return (
    <div className="mx-auto flex min-h-screen max-w-2xl items-center px-6 py-10">
      <div className="w-full rounded-lg border bg-white p-6 shadow-sm">
        <h1 className="mb-2 text-xl font-bold text-red-700">{title}</h1>
        <p className="mb-6 text-sm text-gray-600">{message}</p>
        <div className="flex gap-3">
          <button
            type="button"
            onClick={() => window.location.reload()}
            className="rounded bg-blue-600 px-4 py-2 text-sm text-white hover:bg-blue-700"
          >
            Reîncarcă pagina
          </button>
          <Link to="/" className="rounded border px-4 py-2 text-sm hover:bg-gray-50">
            Mergi la început
          </Link>
        </div>
      </div>
    </div>
  );
}
